'use strict'

import * as React from 'react'
import { connect } from 'react-redux'

import Link from '../helper/link'

import { TidewaysContext } from '../app/context'
import { createHistoryCriteria } from '../domain/history/HistoryCriteria'
import { Report } from '../domain/Report'
import { ApplicationState } from '../redux/ApplicationState'
import { getHistoryTransactionReport } from '../redux/V2/DailyReport/DailyReportState'

interface Props {
    tidewaysContext: TidewaysContext
    report: Report<any> | null
}

export class HistoryOperationComponent extends React.Component<Props> {
    public render() {
        const { application, organization } = this.props.tidewaysContext
        const { report } = this.props

        if (!report) {
            return null
        }

        return (
            <ul className="nav navbar-nav">
                <li className="logo-nav">
                    <a href={'/dashboard?current=' + this.props.tidewaysContext.organization.name}>
                        <img src="/assets/img/tideways-small.png" alt="Dashboard" width="18" height="18" />
                    </a>
                </li>
                <li className="merged">
                    <Link route="dashboard" params={{ current: organization.name }}>
                        {organization.name}
                    </Link>{' '}
                    / <Link route="XhprofOrganizationBundle.Application.show">{application.name}</Link>
                </li>
                <li className="merged">
                    <Link route="XhprofProfilerBundle.History.history">History</Link> &gt; {report.transactionName || 'unknown'}
                </li>
            </ul>
        )
    }
}

export default connect((globalState: ApplicationState) => {
    const criteria = createHistoryCriteria(globalState.tidewaysContext)
    const transactionId = parseInt(globalState.tidewaysContext.route.parameters.operation, 10)

    return {
        report: getHistoryTransactionReport(globalState, criteria, transactionId),
        tidewaysContext: globalState.tidewaysContext,
    }
})(HistoryOperationComponent)
